import { render, staticRenderFns } from "./Competing_A.vue?vue&type=template&id=725b0966&scoped=true&"
import script from "./Competing_A.vue?vue&type=script&lang=js&"
export * from "./Competing_A.vue?vue&type=script&lang=js&"
import style0 from "./Competing_A.vue?vue&type=style&index=0&id=725b0966&scoped=true&lang=css&"
import style1 from "./Competing_A.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725b0966",
  null
  
)

export default component.exports